import Default from './Default';
import Detail from './Detail';

export default {
  Detail,
  Default
};
